import * as React from 'react';
import './RadioInput.scss';
import { CheckboxInput } from '../CheckboxInput/CheckboxInput';
import { default as withInputContainer } from '../withInputContainer/withInputContainer';
export function RadioInput(props) {
  return /*#__PURE__*/React.createElement(CheckboxInput, Object.assign({
    type: "radio"
  }, props));
}
export default withInputContainer({
  metaType: 'boolean',
  type: 'radio',
  inputFirst: true
})(RadioInput);